import {ChipProps} from "@mui/material";
import React from "react";
import {KeyVault, KeyVaultRef} from "../../api/Model";
import {ColorChip} from "../color-chip/ColorChip";


export function KeyVaultChip({keyVault, ...props}: ChipProps & { keyVault: KeyVault | KeyVaultRef }) {
    return (
        <ColorChip
            label={keyVault.name}
            color={keyVault.color}
            {...props}
        />
    )
}